export default [
  {
    path: "/atmreport/activeatmreport",
    name: "activeatmreport",
    component: () => import("@/views/report/activeatmreport/index.vue"),
    meta: {
      pageTitle: "ActiveAtmReport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "ActiveAtmReport",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/barcode",
    name: "barcode",
    component: () => import("@/views/report/activeatmreport/test.vue"),
    meta: {
      pageTitle: "barcode",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "barcode",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/atmeventlog",
    name: "atmeventlog",
    component: () => import("@/views/report/atmeventlog/index.vue"),
    meta: {
      pageTitle: "AtmEventLog",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AtmEventLog",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/cashboxqr",
    name: "cashboxqr",
    component: () => import("@/views/report/cashboxqr/index.vue"),
    meta: {
      pageTitle: "CashboxQR",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "CashboxQR",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/atmrelatedmrcode",
    name: "atmrelatedmrcode",
    component: () => import("@/views/report/atmrelatedmrcode/index.vue"),
    meta: {
      pageTitle: "AtmRelatedMrCode",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AtmRelatedMrCode",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/presentatmtechnicalcondition",
    name: "presentatmtechnicalcondition",
    component: () =>
      import("@/views/report/presentatmtechnicalcondition/index.vue"),
    meta: {
      pageTitle: "PresentAtmTechnicalCondition",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "PresentAtmTechnicalCondition",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/presentatmtechnicalcondition/view/id=:id",
    name: "ViewPresentAtmTechnicalCondition",
    component: () =>
      import("@/views/report/presentatmtechnicalcondition/view.vue"),
    meta: {
      pageTitle: "PresentAtmTechnicalCondition",
      navActiveLink: "presentatmtechnicalcondition",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "PresentAtmTechnicalCondition",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/presentatmtechnicalcondition2",
    name: "presentatmtechnicalcondition2",
    component: () =>
      import("@/views/report/presentatmtechnicalcondition2/index.vue"),
    meta: {
      pageTitle: "PresentAtmTechnicalCondition2",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "PresentAtmTechnicalCondition2",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/presentatmtechnicalcondition2/view/id=:id",
    name: "ViewPresentAtmTechnicalCondition2",
    component: () =>
      import("@/views/report/presentatmtechnicalcondition2/view.vue"),
    meta: {
      pageTitle: "PresentAtmTechnicalCondition2",
      navActiveLink: "presentatmtechnicalcondition2",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "PresentAtmTechnicalCondition2",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/presentatmtechnicalcondition3",
    name: "presentatmtechnicalcondition3",
    component: () =>
      import("@/views/report/presentatmtechnicalcondition3/index.vue"),
    meta: {
      pageTitle: "PresentAtmTechnicalCondition3",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "PresentAtmTechnicalCondition3",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/parkofatm",
    name: "parkofatm",
    component: () => import("@/views/report/parkofatm/index.vue"),
    meta: {
      pageTitle: "ParkOfAtm",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "ParkOfAtm",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/atmisonlineturnover",
    name: "atmisonlineturnover",
    component: () => import("@/views/report/atmisonlineturnover/index.vue"),
    meta: {
      pageTitle: "AtmIsOnlineTurnover",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AtmIsOnlineTurnover",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/getatmcirculationreport",
    name: "getatmcirculationreport",
    component: () =>
      import("@/views/report/atmturnover/getatmcirculationreport.vue"),
    meta: {
      pageTitle: "AtmCirculationReport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AtmCirculationReport",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/getatmturnovertodays",
    name: "getatmturnovertodays",
    component: () =>
      import("@/views/report/atmturnover/getatmturnovertodays.vue"),
    meta: {
      pageTitle: "GetAtmTurnoverToDays",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "GetAtmTurnoverToDays",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/form39",
    name: "form39",
    component: () => import("@/views/report/form39/index.vue"),
    meta: {
      pageTitle: "Form39",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form39",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/mlpredection",
    name: "mlpredection",
    component: () => import("@/views/report/mlpredection/index.vue"),
    meta: {
      pageTitle: "MLPredection",
      breadcrumb: [
        {
          text: "ArtificialIntelligence",
        },
        {
          text: "MLPredection",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/mlpredectionbsc",
    name: "mlpredectionbsc",
    component: () => import("@/views/report/mlpredection/index2.vue"),
    meta: {
      pageTitle: "MLPredectionBsc",
      breadcrumb: [
        {
          text: "ArtificialIntelligence",
        },
        {
          text: "MLPredectionBsc",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/bscturnover",
    name: "bscturnover",
    component: () => import("@/views/report/bscturnover/index.vue"),
    meta: {
      pageTitle: "BscTurnover",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "BscTurnover",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/atmeventlog/view/id=:id",
    name: "ViewAtmEventLog",
    component: () => import("@/views/report/atmeventlog/view.vue"),
    meta: {
      pageTitle: "AtmEventLog",
      navActiveLink: "atmeventlog",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AtmEventLog",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/mlpredection/atmfuturepredectionlist",
    name: "atmfuturepredectionlist",
    component: () =>
      import("@/views/report/mlpredection/atmfuturepredectionlist.vue"),
    meta: {
      pageTitle: "AtmFuturePredection",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AtmFuturePredection",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/mlpredection/bscfuturepredectionlist",
    name: "bscfuturepredectionlist",
    component: () =>
      import("@/views/report/mlpredection/bscfuturepredectionlist.vue"),
    meta: {
      pageTitle: "BscFuturePredection",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "BscFuturePredection",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/atmrentable",
    name: "atmrentable",
    component: () => import("@/views/report/atmrentable/index.vue"),
    meta: {
      pageTitle: "AtmRentable",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AtmRentable",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/atmbscturnoverold",
    name: "atmbscturnoverold",
    component: () => import("@/views/report/atmbscturnoverold/index.vue"),
    meta: {
      pageTitle: "AtmBscTurnoverOld",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AtmBscTurnoverOld",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/recountactdocs",
    name: "recountactdocs",
    component: () => import("@/views/report/recountactdocs/index.vue"),
    meta: {
      pageTitle: "RecountActDocs",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "RecountActDocs",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/form29",
    name: "form29",
    component: () => import("@/views/report/form29/index.vue"),
    meta: {
      pageTitle: "Form29",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form29",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/atmkeys",
    name: "atmkeys",
    component: () => import("@/views/report/atmkeys/index.vue"),
    meta: {
      pageTitle: "AtmKeys",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AtmKeys",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/clearingreport",
    name: "clearingreport",
    component: () => import("@/views/report/clearingreport/index.vue"),
    meta: {
      pageTitle: "ClearingReport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "ClearingReport",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/cmoptiloaddifferencereport",
    name: "cmoptiloaddifferencereport",
    component: () => import("@/views/report/cmoptiloaddifferencereport/index.vue"),
    meta: {
      pageTitle: "CmOptiloadDifferenceReport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "CmOptiloadDifferenceReport",
          active: true,
        },
      ],
    },
  },
  {
    path: "/atmreport/atmencashmenttimingreport",
    name: "atmencashmenttimingreport",
    component: () =>
      import("@/views/report/atmencashmenttimingreport/index.vue"),
    meta: {
      pageTitle: "AtmEncashmentTimingReport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AtmEncashmentTimingReport",
          active: true,
        },
      ],
    },
  },
]
